<script lang="ts">
    import { _ } from "svelte-i18n"
    import { fly } from "svelte/transition"
    import { clickOutside } from "../../utils"
    import { contentOverlay, iframeView, location } from "../../store"
    import MiniLoader from "../widgets/MiniLoader.svelte"
    import { getContent } from "../../api"
    import ContentBlocks from "./ContentBlocks.svelte"
    import { mdiClose } from "@mdi/js"
    import Icon from "../widgets/Icon.svelte"
    import type { ComponentType } from "svelte"

    let loading = false
    let error: any
    let invalid = false

    export let content: string | { component: ComponentType; props?: any; hideClose?: boolean }

    let siteContent: Content

    const load = async () => {
        siteContent = null
        loading = true
        if (content && typeof content == "string") {
            try {
                const c = await getContent(content)
                if (c) {
                    siteContent = c
                } else {
                    invalid = true
                }
            } catch (e) {
                error = e
            }
        }
        loading = false
    }

    let oldContent: string | { component: ComponentType; props?: any; hideClose?: boolean }
    $: {
        if (content != oldContent) {
            oldContent = content
            load()
        }
    }

    let oldPath = $location?.path
    $: if (oldPath != $location?.path) {
        oldPath = $location?.path
        // close on location change
        if (typeof content == "string" || !content.hideClose) {
            $contentOverlay = undefined
        }
    }
</script>

{#if typeof content == "object" && content.hideClose}
    <!-- transparent background -->
    <div class="trans-back"></div>
{/if}

<div
    class="accountoverlay"
    transition:fly="{{ x: 1000 }}"
    use:clickOutside="{(target) => {
        if (typeof content == 'string' || !content.hideClose) {
            content = ''
        }
    }}"
    style="{$iframeView ? 'width: 100vw' : ''}"
>
    <!-- svelte-ignore a11y-invalid-attribute -->
    {#if typeof content == "string" || !content.hideClose}
        <a
            class="closer"
            href=""
            on:click|preventDefault="{() => {
                content = ''
            }}"
        >
            <Icon path="{mdiClose}" size="24px" />
        </a>
    {/if}

    <div class="pad">
        {#if loading}
            <MiniLoader />
        {/if}
        {#if siteContent}
            <ContentBlocks blocks="{siteContent.middle}" />
        {/if}
        {#if typeof content == "object"}
            <svelte:component this="{content.component}" {...content.props} />
        {/if}
    </div>
</div>

<style lang="less">
    @import "../../css/variables.less";

    .trans-back {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1999;
    }

    .accountoverlay :global {
        .pad {
            padding: 0px;
            :global {
                .section_padding {
                    padding-top: 0px;
                }
            }
        }

        position: fixed;
        bottom: 0;
        left: initial;
        right: 0;
        width: 100vw;
        top: 0px;
        overflow-y: scroll;
        overflow-x: hidden;
        z-index: 2000;
        background: var(--surface);
        color: var(--on-surface);

        .closer {
            background: var(--background);
            color: var(--on-background);
            .flex();
            align-items: center;
            border-bottom: 1px solid var(--border-color-default);
            padding: 3px 20px;
            font-size: 18px;
            height: 65px;
        }

        form {
            margin-bottom: 20px;
        }
        .headline {
            font-weight: 800;
            margin-bottom: 20px;
        }
        @media @desktop {
            width: 50vw;
            border-left: 1px solid var(--border-color-default);
            overflow-y: auto;
            .savebutton {
                width: 50vw;
            }
        }
        @media @desktop_large {
            width: 50vw;
            .savebutton {
                width: 50vw;
            }
        }
        @media @desktop_ultralarge {
            width: 30vw;
            .savebutton {
                width: 30vw;
            }
        }
    }
</style>
